import axios from "axios";
import { clientEnv } from "../config/env";

const axiosInstance = axios.create({
    baseURL: clientEnv.apiBaseUrl,
    //baseURL: "/api/api",
    timeout: 60000,
    headers: { "Content-Type": "application/json" },
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const code = err?.response?.data?.code;
    if (
      (status === 403 || code === "IP_BLOCKED") &&
      typeof window !== "undefined" &&
      window.location.pathname !== "/blocked"
    ) {
      window.location.replace("/blocked");
    }
    return Promise.reject(err);
  }
);

export default axiosInstance;
